import React, { useState, useEffect } from 'react';
import VoiceFileUploader from '../components/VoiceFileUploader';
import VoiceTraining from '../components/VoiceTraining';
import VoiceProfileSelector from '../components/VoiceProfileSelector';

const VoiceTrainingPage = () => {
 const [userId, setUserId] = useState(null);
 const [trainingComplete, setTrainingComplete] = useState(false);
 const [selectedVoiceProfile, setSelectedVoiceProfile] = useState(null);

 useEffect(() => {
 const storedUserId = localStorage.getItem('user_id');
 setUserId(storedUserId);
 }, []);

 const handleTrainingComplete = () => {
 setTrainingComplete(true);
 };

 const handleVoiceProfileSelect = (profile) => {
 setSelectedVoiceProfile(profile);
 console.log('Selected voice profile:', profile);
 };

 if (!userId) {
 return (
 <div className="min-h-screen bg-bgMain flex items-center justify-center">
 <div className="text-center">
 <h2 className="text-2xl font-bold text-white mb-4">Please Log In</h2>
 <p className="text-muted">You need to be logged in to access voice training.</p>
 </div>
 </div>
 );
 }

 return (
 <div className="min-h-screen bg-bgMain">
 {/* Header */}
 <div className="bg-primary text-white py-4">
 <div className="max-w-7xl mx-auto px-4">
 <div className="flex items-center justify-between">
 <div className="flex items-center gap-3">
 <div className="w-8 h-8 bg-bgMain rounded-full flex items-center justify-center">
 <span className="text-primary text-lg">🎤</span>
 </div>
 <h1 className="text-2xl font-bold">Custom Voice Training</h1>
 </div>
 <div className="text-sm">
 User: {userId}
 </div>
 </div>
 </div>
 </div>

 {/* Main Content */}
 <div className="max-w-4xl mx-auto px-4 py-8">
 <div className="space-y-8">
 {/* Introduction */}
 <div className="bg-bgSection p-6 rounded-lg">
 <h2 className="text-xl font-bold text-white mb-4">Train Your Custom Voice</h2>
 <p className="text-muted mb-4">
 Upload your voice recordings to create a personalized voice model. This will be used 
 to generate educational videos with your own voice instead of the default AI voice.
 </p>
 <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
 <div className="bg-gray-700 p-3 rounded">
 <h3 className="font-semibold text-white mb-1">1. Upload Files</h3>
 <p className="text-muted">Upload your voice recordings (WAV, MP3, WhatsApp audio, etc.)</p>
 </div>
 <div className="bg-gray-700 p-3 rounded">
 <h3 className="font-semibold text-white mb-1">2. Process Audio</h3>
 <p className="text-muted">System processes and normalizes your audio files</p>
 </div>
 <div className="bg-gray-700 p-3 rounded">
 <h3 className="font-semibold text-white mb-1">3. Train Model</h3>
 <p className="text-muted">AI learns your voice patterns and creates a custom model</p>
 </div>
 </div>
 </div>

 {/* Voice Profile Selector */}
 <VoiceProfileSelector 
 userId={userId}
 onProfileSelect={handleVoiceProfileSelect}
 />

 {/* Voice File Uploader */}
 <VoiceFileUploader 
 userId={userId}
 onUploadComplete={handleTrainingComplete}
 />

 {/* Voice Training Status */}
 <VoiceTraining 
 userId={userId}
 onTrainingComplete={handleTrainingComplete}
 />

 {/* Success Message */}
 {trainingComplete && (
 <div className="bg-green-900 border border-green-700 p-6 rounded-lg">
 <div className="flex items-center gap-3 mb-4">
 <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
 <span className="text-white text-lg">✓</span>
 </div>
 <h3 className="text-xl font-bold text-green-400">Voice Training Complete!</h3>
 </div>
 <p className="text-green-300 mb-4">
 Your custom voice model is ready! All future video generation will use your voice.
 </p>
 <div className="bg-green-800 p-4 rounded">
 <h4 className="font-semibold text-green-400 mb-2">What's Next?</h4>
 <ul className="text-sm text-green-300 space-y-1">
 <li>• Generate videos with your custom voice</li>
 <li>• Your voice will be used for all educational content</li>
 <li>• You can retrain the model anytime with new samples</li>
 </ul>
 </div>
 </div>
 )}

 {/* Tips */}
 <div className="bg-bgSection p-6 rounded-lg">
 <h3 className="text-lg font-bold text-white mb-4">Recording Tips</h3>
 <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
 <div>
 <h4 className="font-semibold text-white mb-2">Audio Quality</h4>
 <ul className="text-muted space-y-1">
 <li>• Use a quiet environment</li>
 <li>• Speak clearly and at normal pace</li>
 <li>• Avoid background noise</li>
 <li>• Record 10-30 seconds per sample</li>
 </ul>
 </div>
 <div>
 <h4 className="font-semibold text-white mb-2">Content Variety</h4>
 <ul className="text-muted space-y-1">
 <li>• Include different types of content</li>
 <li>• Mix questions and explanations</li>
 <li>• Use natural speech patterns</li>
 <li>• Record 5-10 different samples</li>
 </ul>
 </div>
 </div>
 </div>
 </div>
 </div>
 </div>
 );
};

export default VoiceTrainingPage;



